module.exports = __webpack_public_path__ + "static/media/16UNODC10.5278d32f.jpg";